<template>
  <section class="bg-secondary overflow-hidden pt-9">
    <div class="container pt-5 pt-xl-8">
      <div class="row">
        <!-- Title -->
        <div class="col-sm-8 col-lg-5">
          <h3 class="mb-0 text-center text-sm-start">{{ $t('toparticle') }}</h3>
        </div>
      </div>
      <br/>
      <!-- Blog Items -->
      <div class="row">
        <!-- Blog item 1 -->
        <div class="col-md-4 mb-4">
          <article class="card card-hover-shadow rounded-4 overflow-hidden h-100">
            <div class="card-img-top overflow-hidden position-relative">
              <div class="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/4zpqBLyTpsg" allow="autoplay; encrypted-media" allowfullscreen></iframe>
              </div>
            </div>
            <div class="card-body px-3">
            </div>
          </article>
        </div>

        <!-- Blog item 2 -->
        <div class="col-md-4 mb-4">
          <article class="card card-hover-shadow rounded-4 overflow-hidden h-100">
            <div class="card-img-top overflow-hidden position-relative">
              <div class="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/2jqLtIrRqDg" allow="autoplay; encrypted-media" allowfullscreen></iframe>
              </div>
            </div>
            <div class="card-body px-3">
            </div>
          </article>
        </div>

        <!-- Blog item 3 -->
        <div class="col-md-4 mb-4">
          <article class="card card-hover-shadow rounded-4 overflow-hidden h-100">
            <div class="card-img-top overflow-hidden position-relative">
              <div class="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/kIhb5pEo_j0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
              </div>
            </div>
            <div class="card-body px-3">
            </div>
          </article>
        </div>

        <!-- Blog item 4 -->
        <div class="col-md-4 mb-4">
          <article class="card card-hover-shadow rounded-4 overflow-hidden h-100">
            <div class="card-img-top overflow-hidden position-relative">
              <div class="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/ZNu7QWOV1vI" allow="autoplay; encrypted-media" allowfullscreen></iframe>
              </div>
            </div>
            <div class="card-body px-3">
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BlogSection"
};
</script>

<style scoped>
/* Optionally add custom styling */
</style>
